module.exports = __webpack_public_path__ + "standard-empty-state.fbe9a052ec8ae070f23acfbcf4c69752.svg";